/**
 * Hook truy cập dialog đăng ký từ AuthDialogContext.
 */
import { useContext } from 'react';
import { AuthDialogContext } from '../context/AuthDialogContext';

/**
 * @returns {{ isOpen: boolean, openRegisterDialog: Function, closeRegisterDialog: Function }}
 */
export const useRegisterDialog = () => {
  const context = useContext(AuthDialogContext);

  if (!context) {
    throw new Error('useRegisterDialog must be used within AuthDialogProvider');
  }

  return {
    isOpen: context.isRegisterOpen,
    openRegisterDialog: context.openRegisterDialog,
    closeRegisterDialog: context.closeRegisterDialog,
  };
};
